module.exports = __webpack_public_path__ + "static/media/solar_banner.4826ab6f.png";